<template>
	<div>
		<select-general-menu></select-general-menu>
		
		<!-- Content Wrapper. Contains page content -->
		<div class="content-wrapper position-relative">
			<div class="ribbon-wrapper" v-if="isShared">
				<div class="ribbon bg-warning">
					公共
				</div>
			</div>
			<div class="ribbon-wrapper">
				<div class="ribbon" :class="isShared?'bg-warning':'bg-secondary'" v-if="isSystem">
					系统
				</div>
			</div>
			<!-- Content Header (Page header) -->
			<div class="content-header">
				<div class="container-fluid">
					<div class="row mb-2">
						<div class="col-sm-6">
							<h1 class="m-0">
								<i :class="icon"></i>
								<router-link :to="`/mine/generals/${general_id}/dashboard`" style="color: aliceblue;" v-if="isMine || (isSystem && hasOneAuthoritiy('systemGeneral.editDetails'))">{{ name }}</router-link>
								<span v-else>{{ name }}</span>
								<router-link v-if="isMine || (isSystem && hasOneAuthoritiy('systemGeneral.editDetails'))" :to="`/mine/generals/${general_id}/dashboard`" class="link-black text-sm ml-2" data-toggle="dropdown"
									aria-expanded="false"><i class="fas fa-edit mr-1"></i></router-link>
								
								<div class="btn-group" v-if="href && hrefText">
									<a target="_blank" class="link-black text-sm mr-2 ml-2" :href="href">{{hrefText}}</a>
								</div>
							</h1>
						</div><!-- /.col -->
						<div class="col-sm-6">
						</div><!-- /.col -->
					</div><!-- /.row -->
				</div><!-- /.container-fluid -->
			</div>
			<!-- /.content-header -->

			<!-- Main content -->
			<section class="content">
				<div class="container-fluid">
					<!-- Small boxes (Stat box) -->
					<div class="row">
						<section class="col-6 
						" :class="`col-lg-${item} `"
							v-for="(item, index) in layout" :key="index">
							<div v-for="component in generalViewComponentsByIndex(index)" :key="component.id">
								<grid-view-component :entity="component" :theme="theme()">
								</grid-view-component>
							</div>
						</section>
					</div>
				</div><!-- /.container-fluid -->
			</section>
			<!-- /.content -->
		</div>
		<!-- /.content-wrapper -->
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import {
		GET_ENTITY,
	} from '@/api/api.commons.js'
	import gridViewComponent from '@/views/components/generals/gridViewComponentShow.vue'
	import selectGeneralMenu from '@/views/mine/generals/components/selectGeneralMenu.vue'
	
	let themeIndex = -1

	export default {
		components: {
			gridViewComponent,
			selectGeneralMenu
		},
		data() {
			return {
				generalViewComponents: [],
				id: undefined,
				selectedDashboardIndex: undefined,
				general_id: undefined,
				isMine: false,
				isSystem: false,
				layout: [],
				name: '概览',
				href: '#',
				hrefText: undefined,
				
			}
		},
		created() {
			this.id = this.$router.currentRoute.params.id
			GET_ENTITY({
				uri: `/generals/${this.id}`
			}).then(general => {
				this.general_id = general.id
				this.layout = JSON.parse(general.layout)
				this.isSystem = general.system
				this.name = general.name
				this.href = general.href
				this.hrefText = general.hrefText
				GET_ENTITY({
					uri: general._links.components.href
				}).then(components => {
					this.generalViewComponents = components._embedded.generalViewComponents
					$('.connectedSortable').sortable({
						placeholder: 'sort-highlight',
						connectWith: '.connectedSortable',
						handle: '.card-header, .nav-tabs, .small-box',
						forcePlaceholderSize: true,
						zIndex: 999999
					})
					$('.connectedSortable .card-header').css('cursor', 'move')
					$('.connectedSortable .small-box').css('cursor', 'move')
				})
				GET_ENTITY({
					uri: general._links.createdBy.href
				}).then((createdBy) => {
					this.isMine = this.mine(createdBy)
				})
			})
		},
		computed: {
			...mapGetters('system/account', ['hasOneAuthoritiy', 'mine']),
			...mapGetters('global/dashboard', [
				'themes'
			]),
			...mapGetters('mine/generals', [
				'general'
			]),
			selectAnalysisDialogVisible() {
				return this.selectedDashboardIndex !== undefined
			},
		},
		methods: {
			generalViewComponentsByIndex(index) {
				return this.generalViewComponents.filter(t => t.layout === index)
			},
			theme() {
				themeIndex = (themeIndex + 1) % this.themes.length
				return this.themes[themeIndex]
			}
		}
	}
</script>
